import { Query, VisitorGroup } from 'graphql/generated/graphqlTypes';
import { generateMockMobileDevice } from 'mocks/graphqlMocks/mobileDevice';
import { generateMockVisitor } from 'mocks/graphqlMocks/visitor';
import { generateMockVisitorGroup } from 'mocks/graphqlMocks/visitorGroup';
import { VisitorGroupType } from 'utils/VisitorGroup/VisitorGroup';

export function getVisitorGroupsForTenantWithMembersAndTypesDataForQuery(
  getVisitorGroupsForTenant: Array<VisitorGroup>
): Pick<Query, 'getVisitorGroupsForTenant'> {
  return {
    getVisitorGroupsForTenant
  };
}

export const mockedGetVisitorGroupsForTenantWithMembersAndTypesDataForQuery =
  getVisitorGroupsForTenantWithMembersAndTypesDataForQuery([
    generateMockVisitorGroup({
      id: 'mockedVisitorGroupIdExternalUsers1',
      members: [
        generateMockVisitor({
          id: 'mockedVisitorIdExternalUser1',
          name: 'mockedVisitorNameExternalUser1',
          email: 'mockedVisitorEmailExternalUser1'
        }),
        generateMockVisitor({
          id: 'mockedVisitorIdExternalUser2',
          name: 'mockedVisitorNameExternalUser2',
          email: 'mockedVisitorEmailExternalUser2',
          mobileDevices: [generateMockMobileDevice({ id: 'mockedMobileDevice', isRegistered: false })]
        })
      ],
      name: 'co-contractors1',
      type: VisitorGroupType.CoContractors,
      externalRef: 'mockedVisitorGroupExternalRefs'
    }),
    generateMockVisitorGroup({
      id: 'mockedVisitorGroupIdExternalUsers2',
      members: [
        generateMockVisitor({
          id: 'mockedVisitorIdExternalUser3',
          name: 'mockedVisitorNameExternalUser3',
          email: 'mockedVisitorEmailExternalUser3'
        }),
        generateMockVisitor({
          id: 'mockedVisitorIdExternalUser4',
          name: 'mockedVisitorNameExternalUser4',
          email: 'mockedVisitorEmailExternalUser4',
          mobileDevices: [generateMockMobileDevice({ id: 'mockedMobileDevice', isRegistered: false })]
        }),
        generateMockVisitor({
          id: 'mockedVisitorIdExternalUser5',
          name: 'mockedVisitorNameExternalUser5',
          email: 'mockedVisitorEmailExternalUser5',
          mobileDevices: [generateMockMobileDevice({ id: 'mockedMobileDevice', isRegistered: false })]
        })
      ],
      name: 'co-contractors2',
      type: VisitorGroupType.CoContractors,
      externalRef: 'mockedVisitorGroupExternalRefs1'
    }),
    generateMockVisitorGroup({
      id: 'mockedVisitorGroupIdExternalUsers3',
      members: [
        generateMockVisitor({
          id: 'mockedVisitorIdExternalUser6',
          name: 'mockedVisitorNameExternalUser6',
          email: 'mockedVisitorEmailExternalUser6'
        })
      ],
      name: 'co-contractors3',
      type: VisitorGroupType.CoContractors,
      externalRef: 'mockedVisitorGroupExternalRefs2'
    }),
    generateMockVisitorGroup({
      id: 'mockedVisitorGroupIdExternalUsers4',
      name: 'co-contractors4',
      type: VisitorGroupType.CoContractors,
      externalRef: 'mockedVisitorGroupExternalRefs3'
    })
  ]);

export const mockedGetVisitorGroupsForTenantWithMembersAndTypesDataForQueryWithoutFilters =
  getVisitorGroupsForTenantWithMembersAndTypesDataForQuery([
    generateMockVisitorGroup({
      id: 'mockedVisitorGroupId1WithoutFilters',
      name: 'mockedVisitorGroupWithoutFilters',
      type: VisitorGroupType.AzureAd,
      externalRef: 'mockedVisitorGroupExternalRefsWithoutFilters',
      members: [
        generateMockVisitor({
          id: 'mockedVisitorId1WithoutFilters',
          name: 'mockedVisitorName1WithoutFilters',
          email: 'mockedVisitorEmail1WithoutFilters'
        }),
        generateMockVisitor({
          id: 'mockedVisitorId2WithoutFilters',
          name: 'mockedVisitorName2WithoutFilters',
          email: 'mockedVisitorEmail2WithoutFilters',
          mobileDevices: [generateMockMobileDevice({ id: 'mockedMobileDevice', isRegistered: true })]
        })
      ]
    })
  ]);

export const mockedGetVisitorGroupsForTenantWithMembersAndTypesDataForQuery1 =
  getVisitorGroupsForTenantWithMembersAndTypesDataForQuery([
    generateMockVisitorGroup({
      id: 'mockedVisitorGroupIdInstallers1',
      name: 'installers1',
      type: VisitorGroupType.Installers,
      externalRef: 'mockedVisitorGroupExternalRefsInstallers',
      members: [
        generateMockVisitor({
          id: 'mockedVisitorIdInstaller1',
          name: 'mockedVisitorNameInstaller1',
          email: 'mockedVisitorEmailInstaller1'
        }),
        generateMockVisitor({
          id: 'mockedVisitorIdInstaller2',
          name: 'mockedVisitorNameInstaller2',
          email: 'mockedVisitorEmailInstaller2',
          mobileDevices: [generateMockMobileDevice({ id: 'mockedMobileDevice', isRegistered: true })]
        })
      ]
    })
  ]);

export const mockedGetVisitorGroupsForTenantWithMembersAndTypesDataAdmin =
  getVisitorGroupsForTenantWithMembersAndTypesDataForQuery([
    generateMockVisitorGroup({
      id: 'mockedIdInstallers',
      members: [
        generateMockVisitor({
          id: 'mockedVisitorIdInstaller1',
          name: 'installer1',
          email: 'installer1@atlas.com',
          mobileDevices: [
            generateMockMobileDevice({ id: 'mockedMobileDeviceInstaller1CONFIG', isRegistered: true, role: 'CONFIG' }),
            generateMockMobileDevice({ id: 'mockedMobileDeviceInstaller1ACCESS', isRegistered: true, role: 'ACCESS' })
          ],
          isEditable: true
        }),
        generateMockVisitor({
          id: 'mockedVisitorIdInstaller2',
          name: 'installer2',
          email: 'installer2@atlas.com',
          mobileDevices: [
            generateMockMobileDevice({ id: 'mockedMobileDeviceInstaller2ACCESS', isRegistered: false, role: 'ACCESS' }),
            generateMockMobileDevice({ id: 'mockedMobileDeviceInstaller2CONFIG', isRegistered: false, role: 'CONFIG' })
          ],
          isEditable: true
        })
      ],
      name: 'installers',
      type: VisitorGroupType.Installers,
      externalRef: 'mockedExternalRefInstallers'
    })
  ]);
